import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
interface ReviewProps {
  author: string;
  location: string;
  content: string;
  timeAgo: string;
}
export function Review({
  author,
  location,
  content,
  timeAgo
}: ReviewProps) {
  return <div className="border-b border-gray-100 py-4 last:border-0" data-id="element-110">
      <div className="flex items-center mb-2" data-id="element-111">
        <div className="flex text-yellow-400" data-id="element-112">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-current" data-id="element-113" />)}
        </div>
        <span className="text-xs text-blue-600 ml-2 font-medium" data-id="element-114">{author}</span>
        <span className="text-xs text-gray-400 ml-1" data-id="element-115">from {location}</span>
      </div>
      <p className="text-xs text-gray-600 mb-2 leading-relaxed" data-id="element-116">{content}</p>
      <div className="flex items-center justify-between" data-id="element-117">
        <span className="text-[10px] text-gray-400" data-id="element-118">{timeAgo}</span>
        <div className="flex items-center text-gray-500 text-[10px]" data-id="element-119">
          <CheckCircle className="w-3 h-3 mr-1 text-blue-500" data-id="element-120" />
          Verified Review
        </div>
      </div>
    </div>;
}